module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADsSURBVEhL7ZM9CsJAEIWDtl7GK1iKPyjewTvoAQQLL6WChYK1raW1VUR9L2iYjLO7Get88BF2fh4hbLIGD3v4qukOurGCYrqxQmK6sUI83uAKtqGJtfSPa2hiDcfU9GAOH7DLgsYKiWmxgewdYIsFiQ5IadGBV8j+nAWJDkgZYgbZvxQngQ5IGYK3iP1ncRLogJQxzBm5XEcyhWd4/zwnkMiZErlcR4bxM8gaz2NxriAHF5A3YilqIWOzFbbw2+AC4VMuWIZmmfcDfxA29VuxrvHMlgyg9V37UOOZrTCCJ8ibcYRDGMIz22CRZW+wFfsdWLk6/gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-truck/dark/24.png
// module id = 2524
// module chunks = 2